import { render } from "./SubscribeButton.vue?vue&type=template&id=3e087751"
import script from "./SubscribeButton.vue?vue&type=script&lang=js"
export * from "./SubscribeButton.vue?vue&type=script&lang=js"
script.render = render

export default script